import { useCallback, useEffect, useRef, useState } from "react";
import { getRequest } from "../../utils/api";
import { logout } from "../../utils/auth";
import { toast } from "react-toastify";
import PaginationComponent from "../../Component/Pagination/pagination";
import moment from "moment";
import AddSubscriptionModal from "./modal/AddSubscriptionModal";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import InvoiceTemplate from "./invoiceDowloadTemplate";
import Loader from "../../Component/Loader/Loader";
const Subscriptions = () => {
  const [showInvoice, setShowInvoice] = useState(false);
  const [invoiceItem, setInvoiceItem] = useState<any>({});
  const [isLoader, setIsLoader] = useState<any>(true);
  const [dataList, setDataList] = useState<any[]>([]);
  const [page, setPage] = useState<number>(1);
  const [showModal, setShowModal] = useState(false);
  const [editStation, setEditStation] = useState(null);

  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const getDataList = useCallback(async (currentPage: number) => {
    try {
      setIsLoader(true)
      const response = await getRequest(`/subscription/subscriptions?page=${currentPage}&activeTab=All`);
      if (response.status === 'success') {
        setDataList(response.data as any[])
        setIsLoader(false);
        setTotalPages(response.pagination.totalPages);
        setTotalRecords(response.pagination.totalRecords);
      }
      else if (response.status == 'session_expired') {
        setIsLoader(false)
        logout()
      }
      else {
        setIsLoader(false)
        toast.error(response.message);
      }
    } catch (error) {
      setIsLoader(false)
      toast.error("Something went wrong!");
    }
  }, []);

  const isFirstRender = useRef(false);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = true;
      return;
    }
    getDataList(page);
  }, [page]);

  const invoiceRef = useRef<HTMLDivElement>(null);

  const handleDownloadPDF = async (item: any) => {
    setShowInvoice(true)
    setInvoiceItem(item)
    setTimeout(async () => {
      const element = invoiceRef.current;
      if (!element) return;

      const canvas = await html2canvas(element, { scale: 2 });
      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`invoice_${Date.now()}.pdf`);
      setShowInvoice(false)
    }, 100);
  };

  return (
    <>
      {showInvoice && (<Loader />)}
      <div className="hk-pg-wrapper">
        <div className="hk-pg-body py-0">
          <div className="page-wrap">
            <div className="page-content ps-0">
              <div className="page-detail-wrap">
                <header className="page-header">
                  <div>
                    <div className="page-title">
                      <div>
                        <h2 className="mb-1">Manage Billing & Subscription</h2>
                        <p className="fs-13">Control billing cycles, invoices, and active subscriptions</p>
                      </div>
                    </div>
                  </div>
                  <div className="page-options-wrap">
                    <div className="v-separator d-lg-inline-block d-none"></div>
                    <button type="button" className="btn btn-dark btn-rounded" onClick={() => setShowModal(true)}>
                      <span>
                        <span className="icon"><i className="ri-add-line bticon"></i></span>
                        <span>Create New</span>
                      </span>
                    </button>
                    <a className="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover hk-navbar-togglable d-lg-inline-block d-none"
                      href="#" data-bs-toggle="tooltip" data-bs-placement="top" title=""
                      data-bs-original-title="Collapse">
                      <span className="btn-icon-wrap">
                        <span className="feather-icon"><i className="ri-arrow-up-s-line ri-lg"></i></span>
                        <span className="feather-icon d-none"><i className="ri-arrow-down-s-line ri-lg"></i></span>
                      </span>
                    </a>
                  </div>
                </header>
                <div className="page-body">
                  <div data-simplebar className="nicescroll-bar">
                    <div className="container-fluid">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="card">
                            <div className="table-responsive">
                              <table className="table table-hover mb-0">
                                <thead>
                                  <tr>
                                    <th>Invoice ID</th>
                                    <th>User Details</th>
                                    <th>Plan Details</th>
                                    <th>Price</th>
                                    <th>From Date</th>
                                    <th>To Date</th>
                                    <th>Payment Mode</th>
                                    <th className="text-center">Status</th>
                                    <th>Create Date</th>
                                    <th className="text-center">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {dataList && dataList.length > 0 ? (
                                    dataList.map((item, index) => (
                                      <tr>
                                        <td><a href="#" className="fw-bold">#{item.inovoice_order_id ?? "–"}</a></td>
                                        <td>
                                          <div className="media align-items-center">
                                            <div className="media-head me-2">
                                              <div className="avatar avatar-xs rounded">
                                                <img src="dist/img/logo-avatar-3.png" alt="user" className="avatar-img" />
                                              </div>
                                            </div>
                                            <div className="media-body">
                                              <a href="#" className="link-dark table-eclips-text fw-semibold fs-13">{item.invoice_bill_name ?? "–"}</a>
                                              <p className="mb-0 fs-12">{item.invoice_user_id?.user_companyName ?? "–"}</p>
                                            </div>
                                          </div>
                                        </td>
                                        <td><a href="#" className="fw-bold">{item.invoice_plan_name ?? "–"}</a></td>
                                        <td><span className="fw-bold">₹{item.invoice_amount ?? "–"}</span></td>
                                        <td>{moment(item.invoice_plan_start_date).format('DD MMM, YYYY')}</td>
                                        <td>{moment(item.invoice_plan_end_date).format('DD MMM, YYYY')}</td>
                                        <td className="text-center"><a href="#" className="fw-bold text-uppercase">{item.invoice_transaction_id?.method ?? "–"}</a></td>
                                        <td className="text-center">{
                                          item.invoice_status == 1 ? <span className="badge bg-success">Paid</span>
                                            : <span className="badge bg-danger">Unpaid</span>
                                        }</td>
                                        <td>{moment(item.createdAt).format('DD MMM, YYYY')}</td>
                                        <td className="text-center">
                                          <div className="d-flex align-items-center justify-content-center gap-1">
                                            <div className="d-flex gap-1">
                                              <a className="btn btn-icon btn-sm btn-flush-dark btn-border flush-soft-hover" data-bs-toggle="tooltip" data-placement="top" title="" data-bs-original-title="Download Invoice" href="/" onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDownloadPDF(item) }}>
                                                <span className="icon">
                                                  <i className="ri-file-download-fill"></i>
                                                </span>
                                              </a>
                                              <a className="btn btn-icon btn-sm btn-flush-dark btn-border flush-soft-hover" data-bs-toggle="tooltip" data-placement="top" title="" data-bs-original-title="Edit" href="edit-contact.html">
                                                <span className="icon">
                                                  <i className="ri-eye-line"></i>
                                                </span>
                                              </a>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan={10}>
                                        <div className="text-center">No Record Found</div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                            <div className="card-footer d-flex justify-content-between align-items-center">
                              <div className="col-sm">
                                <div className="text-muted">Showing <span className="fw-semibold">{dataList?.length || 0}</span> of <span className="fw-semibold">{totalRecords || 0}</span> Results</div>
                              </div>
                              {totalPages > 0 && <PaginationComponent totalPages={totalPages} currentPage={page} setCurrentPage={setPage} />}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AddSubscriptionModal
          show={showModal}
          onHide={() => {
            setShowModal(false);
            setEditStation(null);
          }}
          editData={editStation}
        />
      </div>
      {invoiceItem && showInvoice && <InvoiceTemplate invoiceItem={invoiceItem} invoiceRef={invoiceRef}></InvoiceTemplate>}
    </>
  );
}
export default Subscriptions